import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FilterCompleteService } from 'src/app/filter-complete/filter-complete';
import { PhysicianFilter } from 'src/app/model/physician-Filter';
import { FilterService } from 'src/app/services/filter.service';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { FilterRecordService } from 'src/app/services/filter-record.service';
import { SearchFilter } from 'src/app/infrastructure/iFilter-component';
import { MedicalFeePaymentManualService } from '../../../services/medical-fee/medical-fee-payment-manual.service';
import { MedicalFeePeriodFilter } from '../../../model/medical-fee/medical-fee-period-filter';

@Component({
  selector: 'app-medical-fee-payment-manual-filter',
  templateUrl: './medical-fee-payment-manual-filter.component.html',
  styleUrls: ['./medical-fee-payment-manual-filter.component.css']
})
export class MedicalFeePaymentManualFilterComponent implements OnInit {

  form: FormGroup;
  @ViewChild('formElement', {static: false}) formElement: ElementRef;
  filterCompletePhysician: FilterCompleteService<PhysicianFilter>;
  medicalFeePeriodFilters: MedicalFeePeriodFilter[];

  constructor(  private formBuilder: FormBuilder,
                private mfpService: MedicalFeePaymentManualService,
                private filterService: FilterService,
                private notificationToastService: NotificationToastService,
                private filterRecordService: FilterRecordService) {

    this.form = this.formBuilder.group({
      number: [''],
      physician: [''],
      from: [''],
      to: [''],
      medicalFeePeriod: [''],
    }, { validators: this.formEmpty('number', 'physician',
                          'from', 'to', 'medicalFeePeriod') });

    this.filterCompletePhysician =
      new FilterCompleteService<PhysicianFilter>([], this.form.controls.physician);
  }

  get f() { return this.form.controls; }

  get filteredPhysicianOptions() { return this.filterCompletePhysician ?
    this.filterCompletePhysician.filteredOptions : []; }

  ngOnInit(): void {

    this.filterService.getMedicalFeeBillPeriodFilters().then( (items) => {
      this.medicalFeePeriodFilters = items;
    });

    this.loadPhysicians();
  }

  private loadPhysicians() {
    this.filterService.getPhysiciansFilter().then( ( items ) => {
      this.filterCompletePhysician =
        new FilterCompleteService<PhysicianFilter>(items, this.form.controls.physician);
    });
  }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  async saveFilters() {
    this.filterRecordService.saveFilters('MedicalFeePaymentManualFilterComponent', this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters('MedicalFeePaymentManualFilterComponent', this.form);
  }

  async search(): Promise<any> {

      try {

         if ( this.form.valid ) {

          return await this.mfpService.getMedicalFeePaymentManualSearchItems(
            this.form.controls.number.value,
            this.form.controls.physician.value ? this.form.controls.physician.value.Id : null,
            this.form.controls.from.value ? this.form.controls.from.value : null,
            this.form.controls.to.value ? this.form.controls.to.value : null,
            this.form.controls.medicalFeePeriod.value ? this.form.controls.medicalFeePeriod.value.Id : null
            );
        } else {
          this.notificationToastService.error('Debe ingresar al menos un filtro', 'Honorarios');
          Object.values( this.form.controls ).forEach( control => {
            control.markAsTouched();
          });
          return [];
        }
      } catch ( err ) {

        this.notificationToastService.error(JSON.stringify( err.error ), 'Honorarios');
      }
  }

  formEmpty( number: string, physician: string, from: string,
    to: string, medicalFeePeriod: string ) {

    return ( formGroup: FormGroup ) => {

    const numberControl = formGroup.controls[number];
    const physicianControl = formGroup.controls[physician];
    const fromControl = formGroup.controls[from];
    const toControl = formGroup.controls[to];
    const medicalFeePeriodControl = formGroup.controls[medicalFeePeriod];

    if ( !numberControl.value &&
      !fromControl.value &&
      !toControl.value &&
      !medicalFeePeriodControl.value &&
    ( !physicianControl.value || typeof physicianControl.value === 'string' ) ) {
      numberControl.setErrors({ formEmpty: true });
      physicianControl.setErrors({ formEmpty: true });
      fromControl.setErrors({ formEmpty: true });
      toControl.setErrors({ formEmpty: true });
      medicalFeePeriodControl.setErrors({ formEmpty: true });
    } else {
      numberControl.setErrors( null );
      physicianControl.setErrors( null );
      fromControl.setErrors( null );
      toControl.setErrors( null );
      medicalFeePeriodControl.setErrors( null );
    }
  };
  }
}
